// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    BookHeart,
    BookImage,
    BookKey,
    BookLock,
    BookMarked,
    BookMinus,
    BookOpen,
    BookOpenCheck,
    BookOpenText,
    BookPlus,
    BookSearch,
    BookText,
    BookType,
    BookUp,
    BookUp2,
    BookUser,
    BookX,
    Bookmark,
    BookmarkCheck,
    BookmarkMinus,
    BookmarkOff,
    BookmarkPlus,
    BookmarkX,
    BoomBox,
    Bot,
    BotMessageSquare,
    BotOff,
    BottleWine,
    BowArrow,
    Box,
    Boxes,
    Braces,
    Brackets,
    Brain,
    BrainCircuit,
    BrainCog,
    BrickWall,
    BrickWallFire,
    BrickWallShield,
    Bridge,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "book-heart" through "bridge", inclusive. */
const shard: Record<string, LucideIcon> = {
    "book-heart": BookHeart,
    "book-image": BookImage,
    "book-key": BookKey,
    "book-lock": BookLock,
    "book-marked": BookMarked,
    "book-minus": BookMinus,
    "book-open": BookOpen,
    "book-open-check": BookOpenCheck,
    "book-open-text": BookOpenText,
    "book-plus": BookPlus,
    "book-search": BookSearch,
    "book-text": BookText,
    "book-type": BookType,
    "book-up": BookUp,
    "book-up-2": BookUp2,
    "book-user": BookUser,
    "book-x": BookX,
    bookmark: Bookmark,
    "bookmark-check": BookmarkCheck,
    "bookmark-minus": BookmarkMinus,
    "bookmark-off": BookmarkOff,
    "bookmark-plus": BookmarkPlus,
    "bookmark-x": BookmarkX,
    "boom-box": BoomBox,
    bot: Bot,
    "bot-message-square": BotMessageSquare,
    "bot-off": BotOff,
    "bottle-wine": BottleWine,
    "bow-arrow": BowArrow,
    box: Box,
    boxes: Boxes,
    braces: Braces,
    brackets: Brackets,
    brain: Brain,
    "brain-circuit": BrainCircuit,
    "brain-cog": BrainCog,
    "brick-wall": BrickWall,
    "brick-wall-fire": BrickWallFire,
    "brick-wall-shield": BrickWallShield,
    bridge: Bridge,
};

export default shard;
